"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  author: "Marcus V.",
  quote: "Pivotal Placement didn't just film our brand; they captured our soul in 4K. Pure artistry.",
  position: "Creative Director"
}, {
  author: "Elena R.",
  quote: "The cinematic quality of their stream production is unmatched. They demand attention.",
  position: "Tech Founder"
}];
export default function GuestStories() {
  return <section data-section-id="223989" id="client-applause" className="bg-background text-foreground py-24 md:py-32 lg:py-40 relative flex items-center min-h-[60vh] overflow-hidden">
      <Carousel opts={{
      loop: true,
      align: "center"
    }} className="w-full">
        <CarouselContent>
          {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
              <div className="flex flex-col items-center justify-center text-center max-w-5xl mx-auto px-16 md:px-24">
                <blockquote className="space-y-8 md:space-y-12">
                  <p className="font-default text-3xl md:text-5xl lg:text-7xl font-extrabold leading-[0.9] tracking-tighter text-balance text-foreground uppercase">
                    "{testimonial.quote}"
                  </p>
                  <footer className="font-mono text-xs md:text-sm tracking-widest uppercase text-muted-foreground">
                    <span className="font-bold text-primary">{testimonial.author}</span>
                    <span className="mx-3 opacity-20">/</span>
                    <span>{testimonial.position}</span>
                  </footer>
                </blockquote>
              </div>
            </CarouselItem>)}
        </CarouselContent>
        <CarouselPrevious variant="ghost" className="left-2 md:left-8 lg:left-12 size-12 border-none bg-transparent hover:bg-transparent text-muted-foreground hover:text-primary opacity-40 hover:opacity-100 transition-all duration-300 hover:scale-110 [&_svg]:size-8" />
        <CarouselNext variant="ghost" className="right-2 md:right-8 lg:left-12 size-12 border-none bg-transparent hover:bg-transparent text-muted-foreground hover:text-primary opacity-40 hover:opacity-100 transition-all duration-300 hover:scale-110 [&_svg]:size-8" />
      </Carousel>
    </section>;
}